export default __webpack_public_path__ + "static/media/desktopAndLaptop.b221a162.svg";